export interface ContainerOffHire {
    container_numbers: string;
    remarks:string;
}
export class ContainerOffHireClass implements ContainerOffHire {
    container_numbers: string;
    remarks:string;

    constructor() {
        this.container_numbers = null;
        this.remarks = null;
    }

}
